import styled, { css, keyframes } from "styled-components";
import { fontSizeVariants } from "../../../globalStyles";

const shake = keyframes`
  0% { transform: translateX(0); }
  20% { transform: translateX(-5px); }
  40% { transform: translateX(5px); }
  50% { transform: translateX(-5px); }
  60% { transform: translateX(5px); }
  70% { transform: translateX(-5px); }
  80% { transform: translateX(5px); }
  90% { transform: translateX(-5px); }
  100% { transform: translateX(0); }
`;

const shakeAnimation = css`
  animation: ${shake} 0.5s ease-in-out;
`;

export const Input = styled.input`
  ${({ $error }) => $error && shakeAnimation};
  background-color: var(--grey-primary);
  border-radius: 8px;
  color: ${({ $color }) => $color};
  font-size: ${fontSizeVariants["h2"]};
  max-width: 64px;
  width: 100% !important;
  height: 64px;
  text-align: center;
  margin: 0;
  outline: none;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::selection {
    background-color: inherit;
  }

  border: ${({ $error }) => ($error ? "2px solid var(--error)" : "none")};

  &:focus-within {
    border: 2px solid var(--orange-primary);
  }
`;

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
